// eslint-disable-next-line @typescript-eslint/no-namespace,unused-imports/no-unused-vars
namespace TescoSW.UI.XGControls {
    export class Margin {
        private _left: number = 0;
        private _top: number = 0;
        private _right: number = 0;
        private _bottom: number = 0;

        private _unit = "px";

        public get left(): number {
            return this._left;
        }
        public get top(): number {
            return this._top;
        }
        public get right(): number {
            return this._right;
        }
        public get bottom(): number {
            return this._bottom;
        }

        public get unit(): string {
            return this._unit;
        }
        public set unit(v: string) {
            this._unit = v;
        }

        constructor(margin?: string) {
            this._parse(margin);
        }

        private _parse(margin?: string): void {
            if (!margin) return;
            const tokens = margin.split(",");
            const num = Number(tokens[0]);

            if (tokens.length === 1) {
                if (!isNaN(num)) this._left = this._right = this._bottom = this._top = num;
            } else if (tokens.length === 2) {
                const num2 = Number(tokens[1]);

                if (!isNaN(num)) this._left = this._right = num;
                if (!isNaN(num2)) this._bottom = this._top = num2;
            } else if (tokens.length === 4) {
                const num2 = Number(tokens[1]);
                const num3 = Number(tokens[2]);
                const num4 = Number(tokens[3]);

                if (!isNaN(num)) this._left = num;
                if (!isNaN(num2)) this._top = num2;
                if (!isNaN(num3)) this._right = num3;
                if (!isNaN(num4)) this._bottom = num4;
            }
        }

        public toString(): string {
            if (this._left === this._right && this._top === this._bottom) {
                if (this._left === this._top) return `margin: ${this._left}${this._unit}; `;
                else return `margin: ${this._bottom}${this._unit} ${this._left}${this._unit}; `;
            } else {
                return `margin: ${this._top}${this._unit} ${this._right}${this._unit} ${this._bottom}${this._unit} ${this._left}${this._unit}; `;
            }
        }
    }
}
